const TOAST_DURATION_MS = 1800;

function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise((resolve, reject) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      resolve();
    } catch (err) {
      reject(err);
    } finally {
      document.body.removeChild(textarea);
    }
  });
}

function showToast(toast) {
  if (!toast) {
    return;
  }

  if (toast.hideTimeout) {
    clearTimeout(toast.hideTimeout);
  }

  toast.hidden = false;
  // Vynuti reflow aby tranzice probehla i pri opakovanem kliknuti.
  void toast.offsetWidth;
  toast.classList.add('is-visible');

  toast.hideTimeout = setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => {
      toast.hidden = true;
    }, 200);
  }, TOAST_DURATION_MS);
}

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-changelog-anchor]');
  if (buttons.length === 0) {
    return;
  }

  const toast = document.querySelector('.changelog-toast');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const anchor = button.getAttribute('data-changelog-anchor');
      if (!anchor) {
        return;
      }

      const url = `${window.location.origin}${window.location.pathname}#${anchor}`;
      if (history.replaceState) {
        history.replaceState(null, '', `#${anchor}`);
      } else {
        window.location.hash = anchor;
      }

      copyToClipboard(url)
        .then(() => showToast(toast))
        .catch(() => {});
    });
  });
});
